
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetogujratcab() {



    const cardData =
    {
        keyword: ' Pune to Gujarat Cab',
        heading: 'Prince Cabs: Pune to Gujarat Cab',
        headingDescription: 'Prince Cabs offers reliable Pune to Gujarat Cab services, perfect for business trips, family travel, pilgrimages, and long-distance journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride from Pune to major cities in Gujarat like Ahmedabad, Surat, Vadodara, and Rajkot. With professional chauffeurs, on-time pickups, and flexible schedules, we make your interstate travel convenient and stress-free. Enjoy comfort, affordability, and trusted service with Prince Cabs’ dedicated cab service from Pune to Gujarat.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Somnath Temple",
    "description": "Somnath Temple, located on the Arabian Sea coast, is one of the 12 Jyotirlingas of Lord Shiva. It has been rebuilt multiple times after invasions and still stands as a symbol of faith and resilience. The temple’s intricate carvings and golden spire attract pilgrims and tourists alike. The evening aarti and light-and-sound show narrate its history beautifully. Waves crashing behind the temple create a spiritual ambiance. It is Gujarat’s most revered pilgrimage site."
  },
  {
    "title": "Gir National Park",
    "description": "Gir National Park is the only natural habitat of the Asiatic lions in the world. Spread across 1,400 sq. km, it is home to lions, leopards, antelopes, and diverse bird species. Safari rides allow visitors to spot lions in their wild surroundings. The park is also known for its rich flora and fauna. Wildlife photographers and adventure lovers flock here throughout the year. Gir is Gujarat’s crown jewel of wildlife tourism."
  },
  {
    "title": "Dwarkadhish Temple",
    "description": "Dwarkadhish Temple, also known as Jagat Mandir, is dedicated to Lord Krishna and is one of the Char Dham pilgrimage sites. Built over 2,000 years ago, its five-story structure is supported by 72 beautifully carved pillars. The temple stands on the banks of the Gomti River. Daily aartis and grand Janmashtami celebrations attract thousands of devotees. The flag atop the temple is changed five times a day. Dwarka is a spiritual cornerstone of Gujarat."
  },
  {
    "title": "Rann of Kutch",
    "description": "The Great Rann of Kutch is a vast white salt desert, stretching endlessly under the sky. It is most famous during the Rann Utsav, a cultural festival showcasing folk music, dance, crafts, and cuisine. Visitors stay in luxury tents and experience the surreal beauty of the salt desert under moonlight. Camel rides and handicraft shopping add charm to the visit. The colorful local culture contrasts the stark white landscape. It is a once-in-a-lifetime destination."
  },
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram in Ahmedabad was Mahatma Gandhi’s residence and is a key site of India’s freedom struggle. It was from here that the historic Dandi March began in 1930. The ashram houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Visitors find inspiration in its simplicity and legacy. Peaceful surroundings by the Sabarmati River enhance the experience. It is a must-visit for history lovers and patriots."
  },
  {
    "title": "Statue of Unity",
    "description": "The Statue of Unity, located near Kevadia, is the world’s tallest statue at 182 meters. It honors Sardar Vallabhbhai Patel, India’s Iron Man. The statue complex includes viewing galleries, museums, and exhibitions. Surrounded by the Satpura and Vindhya ranges, it offers breathtaking landscapes. The light-and-sound shows narrate Patel’s life and India’s unification. It is Gujarat’s most iconic modern attraction and a global landmark."
  },
  {
    "title": "Champaner-Pavagadh Archaeological Park",
    "description": "A UNESCO World Heritage Site, Champaner-Pavagadh Archaeological Park blends Hindu and Islamic architecture. It features forts, palaces, stepwells, and mosques dating back to the 8th century. The Kalika Mata Temple atop Pavagadh Hill is a major pilgrimage center. The site is surrounded by forests and hills, making it scenic and historic. Archaeology lovers find it fascinating to explore. It showcases Gujarat’s medieval heritage."
  },
  {
    "title": "Akshardham Temple, Gandhinagar",
    "description": "Akshardham Temple in Gandhinagar is a modern spiritual and cultural marvel. Dedicated to Lord Swaminarayan, it features intricately carved pink sandstone architecture. The temple complex includes exhibitions, gardens, and an inspiring water show. Thousands of devotees visit daily for darshan and spiritual programs. Its grand design reflects devotion and craftsmanship. Akshardham is both a religious and architectural masterpiece of Gujarat."
  },
  {
    "title": "Junagadh",
    "description": "Junagadh is a historic city at the foothills of Girnar Hills. It is known for Uparkot Fort, Buddhist caves, and Ashoka’s Rock Edicts. The climb to Girnar Hill with thousands of steps is a popular pilgrimage activity. The city also houses ancient temples and stepwells. Junagadh combines spirituality, history, and adventure. It offers a glimpse into Gujarat’s ancient and medieval past."
  },
  {
    "title": "Modhera Sun Temple",
    "description": "Built in the 11th century by the Solanki rulers, Modhera Sun Temple is dedicated to the Sun God. It is known for its grand stepwell, intricately carved pillars, and sanctum that aligns with the equinox sunrise. The temple complex hosts the Modhera Dance Festival, showcasing classical dance performances. Visitors admire its unique blend of science, art, and spirituality. It is an architectural masterpiece of Gujarat’s golden era."
  },
  {
    "title": "Palitana Temples",
    "description": "Palitana in Bhavnagar district is the world’s only mountain with more than 800 Jain temples. Located on Shatrunjaya Hill, devotees climb over 3,500 steps to reach the sacred shrines. The marble temples with detailed carvings create a breathtaking spiritual setting. Pilgrims believe visiting Palitana is essential for salvation. The views from the hilltop are equally mesmerizing. It is a holy destination for Jain devotees worldwide."
  },
  {
    "title": "Saputara",
    "description": "Saputara is Gujarat’s only hill station, located in the Sahyadri ranges. It is known for its pleasant climate, lakes, gardens, and tribal culture. Tourists enjoy boating at Saputara Lake, ropeway rides, and trekking trails. The hill station also hosts cultural festivals showcasing local art and handicrafts. Surrounded by greenery, it is a perfect retreat from Gujarat’s heat. Saputara is a favorite among families and honeymooners."
  },
  {
    "title": "Lothal",
    "description": "Lothal is one of the prominent sites of the Indus Valley Civilization in Gujarat. Archaeological excavations reveal a sophisticated dockyard, bead-making workshops, and drainage systems. The on-site museum displays artifacts like seals, beads, and pottery. History lovers admire its ancient urban planning and maritime trade legacy. It is an educational and fascinating site. Lothal connects modern Gujarat with one of the world’s oldest civilizations."
  },
  {
    "title": "Rani ki Vav, Patan",
    "description": "Rani ki Vav in Patan is a UNESCO World Heritage Site and one of India’s most beautiful stepwells. Built in the 11th century by Queen Udayamati, it is an inverted temple showcasing intricate sculptures. The stepwell features hundreds of idols depicting Hindu deities. During monsoon, it fills with water, adding to its charm. It is both an engineering marvel and a work of art. Rani ki Vav is Gujarat’s architectural jewel."
  },
  {
    "title": "Mandvi Beach",
    "description": "Mandvi Beach in Kutch is a tranquil destination with golden sands and calm waters. It is less crowded, making it perfect for relaxation. Water sports, camel rides, and local food stalls add to the charm. The nearby Vijay Vilas Palace enhances the experience with its royal architecture. Sunsets here are spectacular and romantic. Mandvi Beach combines history, leisure, and natural beauty."
  }
],

  "services": [
    {
      "name": "Pune to Surat Cab",
      "description": "Reliable and comfortable cab service from Pune to Surat. Whether for business or leisure, enjoy smooth rides with professional drivers, well-maintained vehicles, and affordable pricing for a hassle-free journey."
    },
    {
      "name": "Pune to Surat Cab Booking",
      "description": "Book your Pune to Surat cab easily with flexible options including Innova Crysta, Dzire, and Etios. Enjoy door-to-door service, timely pickups, and transparent pricing with a seamless booking experience."
    },
    {
      "name": "Pune to Ahmedabad Cab",
      "description": "Travel from Pune to Ahmedabad with our premium cab services offering comfort, safety, and punctuality. Choose from a range of vehicles including Innova Crysta and Dzire to suit your needs and budget."
    },
    {
      "name": "Cab from Pune to Ahmedabad",
      "description": "Convenient and affordable cab services from Pune to Ahmedabad for both one-way and round trips. Ideal for families, corporate travelers, and tourists, with experienced drivers ensuring a pleasant journey."
    },
    {
      "name": "Pune to Vadodara Cab",
      "description": "Book Pune to Vadodara cabs with competitive rates and excellent service quality. Our fleet includes Innova, Dzire, and Etios cars, ensuring comfortable rides for short or long journeys."
    },
    {
      "name": "Pune to Vadodara Taxi",
      "description": "Affordable taxi service from Pune to Vadodara with professional chauffeurs, clean vehicles, and reliable service. Perfect for outstation trips, business travel, or family visits."
    },
    {
      "name": "Pune to Rajkot Cab",
      "description": "Safe and comfortable cab services from Pune to Rajkot. Choose from luxury Innova Crysta or economical Dzire taxis for a hassle-free and enjoyable trip to Gujarat."
    },
    {
      "name": "Pune to Gandhinagar Cab",
      "description": "Book Pune to Gandhinagar cabs for convenient and stress-free travel. Our well-maintained cars and experienced drivers ensure timely pickups and smooth rides throughout the journey."
    },
    {
      "name": "Pune to Baroda Cab",
      "description": "Affordable and reliable Pune to Baroda cab services with multiple vehicle options including Innova Crysta and Dzire. Ideal for family trips, corporate travel, or group outings."
    },
    {
      "name": "Pune to Gujarat Innova Crysta Taxi",
      "description": "Premium Innova Crysta taxi service from Pune to various destinations in Gujarat. Experience luxury, comfort, and spacious rides perfect for families and corporate clients."
    },
    {
      "name": "Pune to Gujarat Dzire Cab",
      "description": "Cost-effective Dzire cab service for Pune to Gujarat travel. Enjoy comfortable seating, good mileage, and professional drivers at affordable rates."
    },
    {
      "name": "Pune to Gujarat Family Cab",
      "description": "Family-friendly cab services from Pune to Gujarat with spacious vehicles and safety-focused drivers. Perfect for group travel and leisure trips with your loved ones."
    },
    {
      "name": "Pune to Gujarat Tour Package",
      "description": "Explore Gujarat with our customized tour packages starting from Pune. Includes transportation, sightseeing, and comfortable stays with Innova Crysta and Dzire cabs tailored for your trip."
    },
    {
      "name": "Affordable Pune to Gujarat Taxi",
      "description": "Budget-friendly taxi services for Pune to Gujarat routes without compromising on comfort or safety. Choose from reliable vehicles and professional drivers for your travel needs."
    },
    {
      "name": "Luxury Cab Pune to Gujarat",
      "description": "Experience luxury travel from Pune to Gujarat with premium cabs including Innova Crysta. Enjoy top-notch amenities, professional chauffeurs, and a smooth, stylish journey."
    }
  ],
  "tableData": [
    ["Pune to Surat Cab", "Pune to Surat Cab Booking"],
    ["Pune to Ahmedabad Cab", "Cab from Pune to Ahmedabad"],
    ["Pune to Vadodara Cab", "Pune to Vadodara Taxi"],
    ["Pune to Rajkot Cab", "Pune to Gandhinagar Cab"],
    ["Pune to Baroda Cab", "Pune to Gujarat Innova Crysta Taxi"],
    ["Pune to Gujarat Dzire Cab", "Pune to Gujarat Family Cab"],
    ["Pune to Gujarat Tour Package", "Affordable Pune to Gujarat Taxi"],
    ["Luxury Cab Pune to Gujarat"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Trusted Pune to Gujarat Cab Service",
        "WhyChoosedescription": "Prince Cabs offers reliable and comfortable cab services from Pune to various destinations across Gujarat, including Ahmedabad, Surat, Vadodara, and more. Our cabs provide a safe, hassle-free long-distance travel experience for families, corporate travelers, and tourists alike, ensuring you reach your destination relaxed and on time."
    },
    {
        "WhyChooseheading": "Comfortable Vehicles Equipped for Long Journeys",
        "WhyChoosedescription": "Our fleet includes well-maintained sedans and SUVs, such as Swift Dzire, Innova, and more, all equipped with spacious seating, ample luggage space, and air-conditioning. These vehicles are designed to keep you comfortable during the lengthy journey between Pune and Gujarat."
    },
    {
        "WhyChooseheading": "Experienced Drivers Skilled in Long-Distance Routes",
        "WhyChoosedescription": "Our professional drivers have extensive knowledge of highway routes connecting Pune and Gujarat, ensuring safe driving, timely breaks, and efficient navigation to avoid delays. They prioritize your safety and convenience throughout the trip."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Itinerary",
        "WhyChoosedescription": "Whether you need a one-way trip, round trip, or multi-day rental with stops along the way, Prince Cabs offers customizable packages to fit your schedule and travel preferences. Booking is easy via phone, WhatsApp, or our online platform with instant confirmation."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We provide clear and competitive pricing for Pune to Gujarat cab services, inclusive of fuel, tolls, driver allowances, and taxes. Multiple secure payment options are available, including UPI, credit/debit cards, net banking, and cash."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Fleet for Your Safety",
        "WhyChoosedescription": "Each vehicle undergoes thorough cleaning and sanitization before every trip to ensure a hygienic travel environment. Regular maintenance ensures mechanical reliability, while essential safety features provide peace of mind throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
        "WhyChoosedescription": "Our dedicated customer support team is available round-the-clock to assist you with bookings, itinerary changes, or any travel queries. With Prince Cabs, enjoy a seamless and comfortable cab experience from Pune to Gujarat."
    }
]



























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab service from Pune to Gujarat?',
        answer: 'Yes, Prince Cabs offers comfortable and reliable cab services from Pune to various destinations in Gujarat, including Ahmedabad, Surat, Vadodara, and more.',
    },
    {
        question: 'What types of vehicles are available for Pune to Gujarat trips?',
        answer: 'We provide a range of vehicles such as Swift Dzire, Innova, and Tempo Traveller to accommodate solo travelers, families, and large groups.',
    },
    {
        question: 'How long does the journey from Pune to Gujarat usually take?',
        answer: 'The travel time varies by destination but typically ranges from 12 to 15 hours depending on traffic and route taken.',
    },
    {
        question: 'Can I book a round-trip cab from Pune to Gujarat?',
        answer: 'Absolutely! We offer flexible one-way and round-trip packages tailored to your schedule and travel needs.',
    },
    {
        question: 'Are the cabs sanitized and maintained for long-distance travel?',
        answer: 'Yes, all our vehicles are regularly serviced and sanitized to ensure passenger safety and comfort throughout your journey.',
    },
    {
        question: 'What are the approximate fares for Pune to Gujarat cab service?',
        answer: 'Fares depend on the vehicle type, distance, and duration. Contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a cab from Pune to Gujarat?',
        answer: 'Booking is easy via our website or by calling our customer support team with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Jayesh Patel",
        position: "Frequent Traveler",
        text: "I regularly travel from Pune to Gujarat with Prince Cabs. The service is reliable, the drivers are professional, and the cars are well-maintained.",
        image: "/img/testimonial/testimonial-thumb-gujarat-1.png",
    },
    {
        name: "Mrs. Neha Shah",
        position: "Family Traveler",
        text: "We booked an Innova cab from Pune to Gujarat for our family trip. The ride was comfortable, safe, and the driver was very courteous.",
        image: "/img/testimonial/testimonial-thumb-gujarat-2.png",
    },
];
































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Gujarat Cab",
  "description": "Reliable and affordable cab services from Pune to various cities in Gujarat including Surat, Ahmedabad, Vadodara, Rajkot, Gandhinagar, and Baroda. Options for Innova Crysta, Dzire, family cabs, and luxury tours available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Surat Cab",
    "Pune to Surat Cab Booking",
    "Pune to Ahmedabad Cab",
    "Cab from Pune to Ahmedabad",
    "Pune to Vadodara Cab",
    "Pune to Vadodara Taxi",
    "Pune to Rajkot Cab",
    "Pune to Gandhinagar Cab",
    "Pune to Baroda Cab",
    "Pune to Gujarat Innova Crysta Taxi",
    "Pune to Gujarat Dzire Cab",
    "Pune to Gujarat Family Cab",
    "Pune to Gujarat Tour Package",
    "Affordable Pune to Gujarat Taxi",
    "Luxury Cab Pune to Gujarat"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Pune to Gujarat Cab | Surat, Ahmedabad, Vadodara Taxi Service</title>
  <meta
    name="description"
    content="Reliable and affordable cab services from Pune to Surat, Ahmedabad, Vadodara, Rajkot, Gandhinagar, and Baroda. Book Innova Crysta, Dzire, family cabs, and luxury tour packages."
  />
  <meta
    name="keywords"
    content="Pune to Surat Cab, Pune to Surat Cab Booking, Pune to Ahmedabad Cab, Cab from Pune to Ahmedabad, Pune to Vadodara Cab, Pune to Vadodara Taxi, Pune to Rajkot Cab, Pune to Gandhinagar Cab, Pune to Baroda Cab, Pune to Gujarat Innova Crysta Taxi, Pune to Gujarat Dzire Cab, Pune to Gujarat Family Cab, Pune to Gujarat Tour Package, Affordable Pune to Gujarat Taxi, Luxury Cab Pune to Gujarat"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogujratcab ;